import { cancerFields } from "../filter-builder/filter-components/cancer/CancerFields.conf";
import { hematologyFields } from "../filter-builder/filter-components/hematology/HematologyFields.conf";
import { cardioRiskFactorFields } from "../filter-builder/filter-components/cardio-risk/CardioRiskFactor.conf";
import { generalFields } from "../filter-builder/filter-components/general/GeneralFields.conf";
import { riskScoreFields } from "../filter-builder/filter-components/risk-score/RiskScoreFields.conf";
import { chipFields } from "../filter-builder/filter-components/chip/ChipFields.conf";
import { arthroseFields } from "../filter-builder/filter-components/arthrose/ArthroseFields.conf";
import { cardiovascularDiseasesFields } from "../filter-builder/filter-components/cardiovascular-diseases/CardiovascularDiseasesFields.conf";
import { otherFields } from "../filter-builder/filter-components/other-diseases/OtherFields.conf";
import { comorbidityFields } from "../filter-builder/filter-components/comorbidity/ComorbidityFields.conf";
import { qualityOfLifeFields } from "../filter-builder/filter-components/quality-of-life/QualityOfLifeFields.conf";
import { medicationsFields } from "../filter-builder/filter-components/medications/MedicationsFields.conf";
import { laboratoryFields } from "../filter-builder/filter-components/laboratory/LaboratoryFields.conf";
import { hivFields } from "../filter-builder/filter-components/hiv/HivFields.conf";

export const fields = {
    ...generalFields,
    ...riskScoreFields,
    ...cardioRiskFactorFields,
    ...chipFields,
    ...arthroseFields,
    ...cardiovascularDiseasesFields,
    ...otherFields,
    ...comorbidityFields,
    ...hematologyFields,
    ...cancerFields,
    ...qualityOfLifeFields,
    ...medicationsFields,
    ...laboratoryFields,
    ...hivFields,
};
